import React from 'react'

const Title = (props) => {
  return (
    <h1 className='countdown__title'>{props.title}</h1>
  )
}

export default Title
